// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","headerLogo":"Header_headerLogo__2yMm1","headerTitle":"Header_headerTitle__2McR0"};